import { render } from "./ModulosViews.vue?vue&type=template&id=c5cf9e4c&scoped=true"
import script from "./ModulosViews.vue?vue&type=script&lang=js"
export * from "./ModulosViews.vue?vue&type=script&lang=js"

import "./ModulosViews.vue?vue&type=style&index=0&id=c5cf9e4c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c5cf9e4c"]])

export default __exports__